import { buildRefundFormLink, buildTermsLink } from './orderFormLink';
import { normalizeRefundPolicy, DEFAULT_REFUND_POLICY } from './refundPolicy';

export const formatFeedbackLabel = (value) =>
  value
    ? value
        .toString()
        .replace(/_/g, ' ')
        .toLowerCase()
        .replace(/\b\w/g, (char) => char.toUpperCase())
    : 'Feedback';

const formatDealOrderType = (value) =>
  value
    ? value
        .toString()
        .replace(/_/g, ' ')
        .toLowerCase()
        .replace(/\b\w/g, (char) => char.toUpperCase())
    : '';

const buildAmazonLink = (product) => {
  if (product.link) return product.link;
  if (product.asinNumber) return `https://www.amazon.in/dp/${product.asinNumber}`;
  return '';
};

const totalRemainingSlots = (feedbacks = []) =>
  feedbacks.reduce((sum, fb) => sum + Number(fb.remainingSlots ?? 0), 0);

/** Full order message with portal links — for buyers who will fill order/refund forms */
export const buildMediatorOrderMessage = ({
  product,
  feedbacks = [],
  payoutMode = 'LESS',
  payoutAmount = '',
  orderFormLink = '',
  mediatorName = '',
  policyInput = DEFAULT_REFUND_POLICY,
}) => {
  const feedbackList = feedbacks.length > 0
    ? feedbacks
    : [{ feedbackType: product.dealFeedbackType || 'RATING', remainingSlots: product.remainingSlots ?? 0 }];
  const policy = normalizeRefundPolicy(policyInput);
  const refundFormLink = buildRefundFormLink();
  const termsLink = buildTermsLink();
  const orderLink = buildAmazonLink(product);
  const slots = totalRemainingSlots(feedbackList);
  const title = product.brandName
    ? `${product.brandName.toUpperCase()} (${product.productName || 'Product'})`
    : (product.productName || 'Product');

  const lines = [title, ''];

  if (orderLink) {
    lines.push(`Order Link: ${orderLink}`, '');
  }
  if (product.asinNumber) {
    lines.push(`ASIN: ${product.asinNumber}`, '');
  }

  lines.push(`Product price : Below ${product.productAmount ?? '-'}/-`);

  feedbackList.forEach((feedback) => {
    const label = formatFeedbackLabel(feedback.feedbackType);
    const amountPart = payoutAmount ? `${payoutAmount}` : '';
    lines.push(`${label} - ${payoutMode}: ${amountPart}/-`);
  });

  lines.push(
    '',
    'Important: NO REFUND FOR ERROR',
    'Submit rnr within 2-3 days of delivery',
    '',
    `Only ${slots} slot${slots === 1 ? '' : 's'} available`,
    '',
    'Delete/Error - No refund',
    '',
    `Mediator: ${mediatorName || product.mediatorName || '-'}`,
    '',
    'Fill Order/Refund Form in the portal:',
    orderFormLink || '(order form link)',
    '',
    'Fill Refund Form:',
    refundFormLink,
    '',
    '⚠️ Terms and conditions',
    termsLink,
    '',
    'Check code in order form before ordering',
    "Extra slots can't be adjusted",
    '',
    `Product Code: ${product.productCode || '-'}`,
    '',
    `Refund time: ${policy.formCloseDay} working days (Approx)`,
  );

  return lines.join('\n');
};

/** Short product announcement — no portal links, for public deal posts */
export const buildMediatorAnnouncementMessage = ({
  product,
  feedbacks = [],
  payoutMode = 'LESS',
  payoutAmount = '',
}) => {
  const platform = (product.platformName || 'AMAZON').toUpperCase();
  const feedbackList = feedbacks.length > 0
    ? feedbacks
    : [{ feedbackType: product.dealFeedbackType || 'RATING' }];

  const lines = [`🛍️${platform} ORIGINAL DEAL🛍️`, ''];

  feedbackList.forEach((feedback) => {
    const label = formatFeedbackLabel(feedback.feedbackType).toUpperCase();
    const stars = label.includes('RATING') || label.includes('REVIEW') ? ' ⭐⭐⭐⭐⭐' : '';
    lines.push(`${label}${stars}`);
  });

  lines.push('', product.productName || 'Product', '');
  lines.push(`💰ProductPrice-${product.productAmount ?? '-'}`);
  lines.push(`💰${payoutMode}-${payoutAmount || 'DM'}`);

  lines.push('', 'DM FOR LINK');

  return lines.join('\n');
};

/** @deprecated use buildMediatorAnnouncementMessage */
export const buildWhatsAppDealMessage = (
  product,
  feedbacks = [],
  payoutMode = 'LESS',
  payoutAmount = '',
  orderFormLink = '',
  policyInput = DEFAULT_REFUND_POLICY,
) =>
  buildMediatorOrderMessage({
    product,
    feedbacks,
    payoutMode,
    payoutAmount,
    orderFormLink,
    mediatorName: product.mediatorName,
    policyInput,
  });

export const shareWhatsAppMessage = (message) => {
  window.open(`https://wa.me/?text=${encodeURIComponent(message)}`, '_blank', 'noopener,noreferrer');
};

export { formatDealOrderType };
